let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dCivC")).then(() => parcelRequire('8bN1h'));